/** Normaliza teléfono a dígitos (string), corrigiendo sufijos .0 de Excel. */
export function sanitizePhone(value, maxLen = 20) {
  let s = String(value ?? '').trim();
  if (!s || /^nan$/i.test(s)) return '';
  if (/^\d+\.0+$/.test(s)) {
    s = s.split('.', 1)[0];
  }
  const hasPlus = s.startsWith('+');
  const digits = s.replace(/\D/g, '');
  if (!digits) return '';
  const out = (hasPlus ? '+' : '') + digits;
  return out.slice(0, maxLen);
}

export function isValidPhone(value) {
  const s = sanitizePhone(value);
  if (!s) return true;
  return /^\+?[0-9]+$/.test(s) && s.length <= 20;
}
